/**
 * Number of seconds that we consider an intro has
 */
export const INTRO_SECONDS = 5;

// The number of milliseconds in one day
export const DAY_IN_MILLISECONDS = 1000 * 60 * 60 * 24;

export const USER_INTERFACE_BASE_URL = 'https://platform.replai.io';
